/**
 * Simple Toast Utility
 * Hiển thị thông báo cho user
 */

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastOptions {
  duration?: number;
  position?: 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left';
}

const showToast = (message: string, type: ToastType, options: ToastOptions = {}) => {
  const {
    duration = 3000,
    position = 'top-right'
  } = options;

  // Create toast element
  const toast = document.createElement('div');
  toast.className = `fixed z-[9999] max-w-sm px-6 py-4 rounded-lg shadow-lg transform transition-all duration-300 ease-out`;

  // Position
  const positionClasses = {
    'top-right': 'top-4 right-4',
    'top-center': 'top-4 left-1/2 -translate-x-1/2',
    'top-left': 'top-4 left-4',
    'bottom-right': 'bottom-4 right-4',
    'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
    'bottom-left': 'bottom-4 left-4',
  };
  toast.className += ` ${positionClasses[position]}`;

  // Type styling
  const typeStyles = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-500 text-white',
    info: 'bg-blue-500 text-white',
  };
  toast.className += ` ${typeStyles[type]}`;

  // Icons
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  toast.innerHTML = `
    <div class="flex items-center space-x-3">
      <span class="text-xl font-bold">${icons[type]}</span>
      <span class="font-medium">${message}</span>
    </div>
  `;

  // Add to DOM
  document.body.appendChild(toast);

  // Animate in
  setTimeout(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  }, 10);

  // Remove after duration
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = position.includes('top') ? 'translateY(-20px)' : 'translateY(20px)';
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 300);
  }, duration);
};

export const toast = {
  success: (message: string, options?: ToastOptions) => showToast(message, 'success', options),
  error: (message: string, options?: ToastOptions) => showToast(message, 'error', options),
  warning: (message: string, options?: ToastOptions) => showToast(message, 'warning', options),
  info: (message: string, options?: ToastOptions) => showToast(message, 'info', options),
};

export default toast;

